import { render } from "./ConfirmPhoneModal.vue?vue&type=template&id=201f335b&scoped=true"
import script from "./ConfirmPhoneModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPhoneModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPhoneModal.vue?vue&type=style&index=0&id=201f335b&scoped=true&lang=css"

import exportComponent from "../../../../../client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201f335b"],['__file',"views/order/assets/components/confirmPhone/ConfirmPhoneModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "201f335b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('201f335b', __exports__)) {
    api.reload('201f335b', __exports__)
  }
  
  module.hot.accept("./ConfirmPhoneModal.vue?vue&type=template&id=201f335b&scoped=true", () => {
    api.rerender('201f335b', render)
  })

}


export default __exports__